class PublicReservationHelper {
  /**
   * Parse time in AM/PM format (e.g. "2:30pm")
   */
  static parseAmPmTime(timeStr) {
    if (!timeStr) return null;

    const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(am|pm)/i);
    if (!match) return null;

    let [, hours, minutes, meridian] = match;
    hours = parseInt(hours, 10);
    minutes = parseInt(minutes, 10);

    if (meridian.toLowerCase() === "pm" && hours !== 12) hours += 12;
    if (meridian.toLowerCase() === "am" && hours === 12) hours = 0;

    return { hours, minutes };
  }

  /**
   * Parse time in 24-hour format (e.g. "12:30:00")
   */
  static parse24HourTime(timeStr) {
    if (!timeStr) return null;

    const match = timeStr.match(/(\d{2}):(\d{2})(?::\d{2})?/);
    if (!match) return null;

    const [, hours, minutes] = match;
    return {
      hours: parseInt(hours, 10),
      minutes: parseInt(minutes, 10),
    };
  }

  /**
   * Format date for UI display
   */
  static formatCustomDate(
    timestring,
    daystring,
    monthstring,
    servicestarttime
  ) {
    const year = new Date().getFullYear();
    const day = Number(daystring);
    const month = Number(monthstring) - 1; // JS months are 0-based

    const selectedTime = this.parseAmPmTime(timestring);
    const serviceTime = this.parse24HourTime(servicestarttime);

    if (
      !selectedTime ||
      !serviceTime ||
      Number.isNaN(day) ||
      Number.isNaN(month)
    ) {
      console.error("Invalid date inputs", {
        timestring,
        servicestarttime,
        daystring,
        monthstring,
      });
      return "";
    }

    let dateObj = new Date(
      year,
      month,
      day,
      selectedTime.hours,
      selectedTime.minutes
    );

    const serviceStart = new Date(
      year,
      month,
      day,
      serviceTime.hours,
      serviceTime.minutes
    );

    // If selected time is before service start, move to next day
    if (dateObj < serviceStart) {
      dateObj.setDate(dateObj.getDate() + 1);
    }

    if (isNaN(dateObj.getTime())) {
      console.error("Invalid Date created", dateObj);
      return "";
    }

    return new Intl.DateTimeFormat(navigator.language || "en-IN", {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(dateObj);
  }

  /**
   * Returns reservation Date in UTC (for backend)
   */
  static getReservationDateTime(
    timestring,
    daystring,
    monthstring,
    servicestarttime
  ) {
    const year = new Date().getFullYear();
    const day = Number(daystring);
    const month = Number(monthstring) - 1;

    const selectedTime = this.parseAmPmTime(timestring);
    const serviceTime = this.parse24HourTime(servicestarttime);

    if (
      !selectedTime ||
      !serviceTime ||
      Number.isNaN(day) ||
      Number.isNaN(month)
    ) {
      return null;
    }

    let dateObj = new Date(
      year,
      month,
      day,
      selectedTime.hours,
      selectedTime.minutes
    );

    const serviceStart = new Date(
      year,
      month,
      day,
      serviceTime.hours,
      serviceTime.minutes
    );

    if (dateObj < serviceStart) {
      dateObj.setDate(dateObj.getDate() + 1);
    }

    return new Date(
        dateObj.getFullYear(),
        dateObj.getMonth(),
        dateObj.getDate(),
        dateObj.getHours(),
        dateObj.getMinutes()
    );
  }
}

export default PublicReservationHelper;
